const productHistoryType = {
  GET_HISORIES: 'GET_HISORIES',
  GET_HISTORY_LIST: 'GET_HISTORY_LIST',
  CLEAR_REDUCER: 'CLEAR_REDUCER',
};

export default productHistoryType;
